import * as u from './utils';
import Flickity from 'flickity';
import imagesloaded from 'flickity-imagesloaded'; // eslint-disable-line no-unused-vars

export default () => {
    const containers = document.querySelectorAll('.sliding-carousel');

    if (!containers) {
        return;
    }

    for (const el of containers) {
        const images = el.querySelector('.sliding-carousel__images');
        let icons = el.querySelectorAll('.sliding-carousel__icon-wrap');

        const flkty = new Flickity(images, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: true,
            wrapAround: false,
            adaptiveHeight: false,
            imagesLoaded: true,
            resize: true,
        });

        const slideChange = (index) => {
            const imageLookup = el.querySelector('.sliding-carousel__image:nth-child(' + (index + 1) + ')');
            let imageIcons = imageLookup.dataset.icons;

            u.removeClass(icons, 'is-active');

            if (!imageIcons) {
                return;
            }

            imageIcons = imageIcons.split(',');
            for (let i = 0; i < imageIcons.length; i++) {
                u.addClass(icons[parseInt(imageIcons[i], 10) - 1], 'is-active');
            }
        };

        if (icons) {
            icons = Array.from(icons);
            flkty.on('change', slideChange);
            slideChange(0);
        }
    }

    u.trigger('resize', window);
    setTimeout(() => {
        u.trigger('resize', window);
    }, 1000);
    setTimeout(() => {
        u.trigger('resize', window);
    }, 5000);
};
